import { getCloudPACSToken } from "@custom/Utils/authUtils";
import { _machineUrls } from "@custom/Utils/constants/apiUrls";
import { ApiResponse, MachineProps } from "@custom/Utils/constants/interfaces";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getMachineListApi = {
    getAllMachineListApi: createAsyncThunk(
        "machine/get",
        async (props: MachineProps, { rejectWithValue }) => {
            const pacs_token = getCloudPACSToken();
            try {
                let url = _machineUrls.get;
                const queryParams = [];

                if (props.search?.trim()) {
                    queryParams.push(`dicomDeviceName=${encodeURIComponent(props.search.trim())}`);
                }

                if (props.limit) {
                    queryParams.push(`limit=${props.limit}`);
                }
                if (props.pageNumber) {
                    queryParams.push(`pageNumber=${props.pageNumber}`);
                }

                if (queryParams.length > 0) {
                    url += `?${queryParams.join('&')}`;
                }

                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${pacs_token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch machine list');
                }

                const data: ApiResponse<any> = await response.json();
                return data;
            } catch (error) {
                return rejectWithValue(error);
            }
        }
    ),
};
